import script from "./vtextinput.vue?vue&type=script&setup=true&lang=js"
export * from "./vtextinput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__